import { useRouter } from 'next/router';

export const useEventContext = () => {
  const {
    route,
    query: { query: searchQuery, pageSlug, productSlug },
  } = useRouter();
  const categoryPages = ['/accessories', '/apparel', '/bags', '/jewelry', '/sneakers'];
  const isNestedCategoryPage = pageSlug && productSlug;

  if (route.includes('/brand')) {
    return 'brand_page';
  }
  if (isNestedCategoryPage || categoryPages.includes(route)) {
    return 'categories';
  }
  if (route.includes('/collections')) {
    return 'collection';
  }
  if (route.includes('/search') && searchQuery) {
    return 'search_results';
  }
  if (route.includes('/search') && !searchQuery) {
    return 'shop_all';
  }
  if (route.includes('/timeline')) {
    return 'timeline';
  }
  if (route.includes('/wants')) {
    return 'wants';
  }
  return 'pdp';
};
